import { ChangeEvent, FormEvent, useContext, useState } from "react"
import { InputText } from "primereact/inputtext"
import { Button } from "primereact/button"
import { Card } from "primereact/card"
import userContext from "../../context/user"
import commonStyles from "../common.module.css"
import { NavLink } from "react-router-dom"
import Logo from "../common/Logo"
import styles from "./styles.module.css"
import { useAuthResetPassword } from "../../api/queries/useAuthResetPassword"
import globalToastContext from "../../context/globalToast"
import { Collapsible } from "../common/Collapsible"

export default function Auth({ loginFailed }: Props) {
  const { login } = useContext(userContext)
  const { ref } = useContext(globalToastContext)

  const resetPassword = useAuthResetPassword()

  const [username, setUsername] = useState<string>("")
  const handleUsernameChange = (e: ChangeEvent<HTMLInputElement>) => setUsername(e.target.value)

  const [password, setPassword] = useState<string>("")
  const handlePassChange = (e: ChangeEvent<HTMLInputElement>) => setPassword(e.target.value)

  const [email, setEmail] = useState<string>("")
  const handleEmailChange = (e: ChangeEvent<HTMLInputElement>) => setEmail(e.target.value)

  const [isPassVisible, setIsPassVisible] = useState<boolean>(false)
  const handleIsPassVisibleChange = () => setIsPassVisible(!isPassVisible)

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    await login(username, password)
  }

  const onPassReset = async () => {
    await resetPassword.mutateAsync({ email })

    ref?.current?.show({
      severity: "info",
      summary: "Na váš e-mail byly odeslány další instrukce pro změnu hesla."
    })
  }

  const footer = (
    <>
      <div className={"text-center"}>
        <NavLink to={"/reset-password"} className={"text-color text-xs"}>
          Zapomněli jste heslo?
        </NavLink>
      </div>
      <div className={"text-center"}>
        <NavLink to={"/registration"} className={"text-color text-xs"}>
          Ještě nemáte účet? Zaregistrujete se.
        </NavLink>
      </div>
    </>
  )

  return (
    <form onSubmit={handleSubmit}>
      <Card title={""} footer={footer} className={styles.card}>
        <Logo />

        <h2>Přihlásit se</h2>

        <div className={"p-fluid"}>
          <div className={"field"}>
            <label className={commonStyles.labelRequired}>Jméno:</label>
            <InputText required={true} value={username} onChange={handleUsernameChange}
              autoComplete="username" />
            {/* <small className={commonStyles.fieldHelp}>Uživatelské jméno nebo e-mail.</small> */}
          </div>

          <div className={"field"}>
            <label className={commonStyles.labelRequired}>Heslo:</label>
            <div className={"p-inputgroup"}>
              <InputText type={isPassVisible ? "text" : "password"} required={true} value={password}
                onChange={handlePassChange} autoComplete="password" />
              <Button type={"button"} icon={isPassVisible ? "pi pi-eye-slash" : "pi pi-eye"}
                className={"p-button-secondary"} onClick={handleIsPassVisibleChange} />
            </div>
          </div>
        </div>

        <div className={"text-center"}>
          <Button label={"Přihlásit"} disabled={!username || !password}
            icon={"pi pi-sign-in"} className="p-button p-button-sm" />

          <Collapsible isOpen={loginFailed}>
            <div className="text-sm pt-3 pb-1">
              &hellip;nebo si požádejte o změnu hesla
            </div>

            <div className="p-inputgroup">
              <InputText value={email} onChange={handleEmailChange} placeholder="Váš e-mail" />
              <Button className="p-button p-button-sm p-button-secondary"
                icon="pi pi-send" type="button" disabled={!email} onClick={onPassReset} />
            </div>
          </Collapsible>
        </div>
      </Card>

      <div className={styles.version}>v{process.env.REACT_APP_VERSION}</div>
    </form>
  )
}

interface Props {
  loginFailed: boolean;
}
